import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class PriceService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PRICE_UPDATE(
          $id: String!
          $data: PriceInput!
          $manage: ManageInput!
        ) {
          priceUpdate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.priceUpdate;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PRICE_DESTROY($ids: [String!]!  $manage: ManageInput!) {
          priceDestroy(ids: $ids,  manage: $manage) 
        }
      `,

      variables: {
        ids,
        manage,
      },
    });

    return response.data.priceDestroy;
  }

  static async create(data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PRICE_CREATE($data: PriceInput!  $manage: ManageInput!) {
          priceCreate(data: $data,   manage: $manage) {
            id
          }
        }
      `,

      variables: {
        data,
        manage,
      },
    });

    return response.data.priceCreate;
  }

  static async import(values, importHash, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PRICE_IMPORT(
          $data: PriceInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          priceImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.priceImport;
  }

  static async find(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PRICE_FIND($id: String!  $manage: ManageInput!) {
          priceFind(id: $id,  manage: $manage) {
            id
            amount
            currency
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.priceFind;
  }

  static async list(filter, orderBy, limit, offset, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PRICE_LIST(
          $filter: PriceFilterInput
          $orderBy: PriceOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          priceList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              amount
              currency
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });

    return response.data.priceList;
  }

  static async listAutocomplete(query, limit, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PRICE_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          priceAutocomplete(query: $query, limit: $limit,  manage: $manage) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        manage
      },
    });

    return response.data.priceAutocomplete;
  }
}
